import md5 from 'md5';
import { PostMSG } from 'utils';
import { getStoreData, getStoreToken } from 'utils/storage';



export const downloadFile = async (
  url,
  msgString,
  method?: 'GET' | 'POST',
  body?: any,
) => {
  try {
    const token = await getStoreToken();
    const idNo = await getStoreData('idNo');
    const phone = await getStoreData('phone');
    const refCode = await getStoreData('refCode');
    const agentCode = await getStoreData('agentCode');
    const secretKey = await getStoreData('secretKey');
    const investmentNumber = await getStoreData('investmentNumber');
    const headers = {
      idNo,
      phone,
      refCode,
      agentCode,
      secretKey,
      investmentNumber,
      Authorization: token
        ? `Bearer ${token}`
        : `Bearer ${md5(`${idNo}${phone}${refCode}${agentCode}${investmentNumber}${secretKey}`)}`,
      'Content-Type': 'application/json',
    };
    var data;
    if (method == 'POST') {
      data = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(body || {}),
      });
    } else {
      data = await fetch(url, {
        method: method || 'GET',
        headers,
      });
    }
    data.blob().then((t: any) => {
      const reader = new FileReader();
      let dataurl = window.URL.createObjectURL(t);
      let a = document.createElement('a');
      a.href = dataurl;
      a.download = 'File';
      reader.readAsDataURL(t);
      reader.onloadend = () => {
        const base64data: any = reader.result;
        PostMSG(
          msgString,
          `${base64data.replace('data:application/pdf;base64,', '') || ''}`,
        );
      };
      a.click();
    });
  } catch (error) {
    Log('errror', error)
  }
};
